
// constants as defined in RevoXef’s App\Models\Config\PaymentMethod
const DONT_ALLOW = 0
const CONVERT_AS_TIP = 1
const WITH_CASH = 2 // default
const ASK = 3
// const WITH_GIFT_CARD = 4
const AS_TIP_WITH_CONFIRMATION = 5
// const WITH_INTOUCH = 6

export default {
  DONT_ALLOW,
  CONVERT_AS_TIP,
  WITH_CASH,
  ASK,
  // WITH_GIFT_CARD,
  AS_TIP_WITH_CONFIRMATION,
  // WITH_INTOUCH,
}
